// istanbul ignore file
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type BarKpiDataObject } from '../types'

export interface BubbleKpiBarGraphState {
  isLoading: boolean
  error: boolean
  data: BarKpiDataObject | undefined
  httpStatus: number
}

const initialState: BubbleKpiBarGraphState = {
  isLoading: true,
  error: false,
  data: undefined,
  httpStatus: 0
}

const bubbleKpiBarGraphSlice = createSlice({
  name: 'bubbleKpiBarGraph',
  initialState,
  reducers: {
    bubbleKpiBarGraphLoadingAction: (state) => {
      return {
        isLoading: true,
        error: false,
        data: undefined,
        httpStatus: 0
      }
    },
    bubbleKpiBarGraphUpdateAction: (state, action: PayloadAction<{ data: BarKpiDataObject, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: false,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    bubbleKpiBarGraphErrorAction: (state, action: PayloadAction<number>) => {
      return {
        isLoading: false,
        error: true,
        data: undefined,
        httpStatus: action.payload
      }
    },
    bubbleKpiBarGraphResetAction: () => {
      return initialState
    }
  }
})

export const {
  bubbleKpiBarGraphLoadingAction,
  bubbleKpiBarGraphUpdateAction,
  bubbleKpiBarGraphErrorAction,
  bubbleKpiBarGraphResetAction
} = bubbleKpiBarGraphSlice.actions

export default bubbleKpiBarGraphSlice.reducer
